<template>
  <div class="row">
    <div class="col-md-12">
      <span class="badge badge-pill badge-info small px-2 py-2 d-inline-block mr-1 mb-1" v-for="item in schedule">{{item}}</span>
    </div>
  </div>
</template>
<script>
  import days from './../mixins/days'

  export default {
    props: ['schedules'],
    mixins: [days],
    name: "schedule-badge",
    data: () => ({
      schedule: []
    }),
    mounted() {
      const days = JSON.parse(this.schedules).map(el => el.day).sort((a, b) => a - b);
      const schedules = new Set([...days]);
      this.schedule = Array.from(schedules).map(schedule => this.days.find(el => el.pos === schedule).day)
    }
  }
</script>

<style scoped>

</style>
